<template>
  <div id="header">
    <a-row id="pc_menu" type="flex" justify="space-between" align="middle">
      <a-col id="logo_header" :offset="4" :span="5">
        <img class="logo" src="@/assets/company_logo_icon.png" />
        <div class="logo_bottom_text">——广东庞盛科技有限公司——</div>
      </a-col>
      <a-col :span="15">
        <a-menu v-model="current" mode="horizontal">
          <a-menu-item key="/">
            <router-link :to="'/'" class="iconfont icon-shouye-xianxing">
              首页
            </router-link>
          </a-menu-item>
          <a-sub-menu key="about">
            <span slot="title" class="submenu-title-wrapper">
              关于公司
              <!-- <icon-font class="arrowicon" :type="arrowDirection"/> -->
            </span>
            <a-menu-item key="/Profile">
              <router-link
                :to="'/Profile'"
                class="iconfont icon-shouye-xianxing"
              >
                公司简介
              </router-link>
            </a-menu-item>
            <a-menu-item key="/Qualifications">
              <router-link
                :to="'/Qualifications'"
                class="iconfont icon-shouye-xianxing"
              >
                公司资质
              </router-link>
            </a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="product">
            <span slot="title" class="submenu-title-wrapper">
              产品展示
              <!-- <icon-font class="arrowicon" :type="arrowDirection"/> -->
            </span>
            <a-menu-item key="/KwhProduct">
              <router-link
                :to="{
                  name: 'KwhProduct',
                  params: { groupname: '智慧用电管理终端' },
                }"
              >
                智慧用电管理终端
              </router-link>
            </a-menu-item>
            <a-menu-item key="/SingleProduct">
              <router-link
                :to="{
                  name: 'SingleProduct',
                  params: { groupname: '单相重合闸系列' },
                }"
              >
                单相重合闸系列
              </router-link>
            </a-menu-item>
            <a-menu-item key="/ThreePaseProduct">
              <router-link
                :to="{
                  name: 'ThreePaseProduct',
                  params: { groupname: '三相重合闸系列' },
                }"
              >
                三相重合闸系列
              </router-link>
            </a-menu-item>
            <a-menu-item key="/MonitorProduct">
              <router-link
                :to="{
                  name: 'MonitorProduct',
                  params: { groupname: '智能监控系列' },
                }"
              >
                智能监控系列
              </router-link>
            </a-menu-item>
          </a-sub-menu>
          <a-sub-menu>
            <span slot="title" class="submenu-title-wrapper"> 解决方案 </span>
            <a-menu-item key="/KwhProgramme">
              <router-link
                :to="{
                  name: 'KwhProgramme',
                  params: { groupname: '智慧用电管理终端' },
                }"
              >
                智慧用电管理终端
              </router-link>
            </a-menu-item>
            <a-menu-item key="/SingleProgramme">
              <router-link
                :to="{
                  name: 'SingleProgramme',
                  params: { groupname: '单相重合闸系列' },
                }"
              >
                单相重合闸系列
              </router-link>
            </a-menu-item>
            <a-menu-item key="/ThreePaseProgramme">
              <router-link
                :to="{
                  name: 'ThreePaseProgramme',
                  params: { groupname: '三相重合闸系列' },
                }"
              >
                三相重合闸系列
              </router-link>
            </a-menu-item>
            <a-menu-item key="/MonitorProgramme">
              <router-link
                :to="{
                  name: 'MonitorProgramme',
                  params: { groupname: '智能监测系列' },
                }"
              >
                智能监测系列
              </router-link>
            </a-menu-item>
          </a-sub-menu>
          <a-sub-menu>
            <span slot="title" class="submenu-title-wrapper"> 新闻资讯 </span>
            <a-menu-item key="/Company">
              <router-link
                :to="{
                  name: 'Company',
                  params: { groupname: '公司资讯' },
                }"
              >
                公司资讯
              </router-link>
            </a-menu-item>
            <a-menu-item key="/Trade">
              <router-link
                :to="{
                  name: 'Trade',
                  params: { groupname: '行业资讯' },
                }"
              >
                行业资讯
              </router-link>
            </a-menu-item>
          </a-sub-menu>
          <a-menu-item key="/Contact">
             <router-link
                :to="{
                  name: 'Contact',
                  params: { groupname: '联系我们' },
                }"
              >
                联系我们
              </router-link>
          </a-menu-item>
        </a-menu>
      </a-col>
    </a-row>
  </div>
</template>
<script>
export default {
  name: "Header",
  components: {},
  methods: {
    //滑过多级菜单头
    mouseenterArrow: function () {
      //箭头向下
      this.arrowDirection = "icon-xiangxia";
    },
    //跳转产品列表页面
    navProductListPage: function (e, groupName) {
      this.$router.push({
        name: "ProductConter",
        params: { groupname: groupName },
      });
    },
    //鼠标离开多级菜单头
    mouseleaveArrow: function () {
      //箭头向上
      this.arrowDirection = "icon-xiangshang";
    },
  },
  data() {
    return {
      current: ["home"], //默认选中
      arrowDirection: "icon-xiangshang",
    };
  },
  created: function () {
    console.log("当前路由", this.$route.path);
    if (this.$route.path != undefined && this.$route.path != null) {
      this.current = [this.$route.path];
    }
  },
};
</script>
<style scoped>
@media screen and (max-width: 850px) {
  #logo_header {
    display: none;
  }
}
/* 头部 begin */
#pc_menu {
  margin-bottom: 15px;
}
.header_box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.logo {
  width: 240px;
  height: 70px;
}
.logo_bottom_text {
  color: #1d2088;
  font-size: 16px;
  padding: 0px 10px;
}
/* 头部 end */

/* 菜单 begin */
.ant-menu {
  font-size: 24px;
  color: #282828;
  font-weight: 400;
}
.netMenuItem {
  font-size: 24px;
  color: #282828;
  font-weight: 400;
}
.netMenuItem:hover {
  color: #1d2088;
}
/* 图标 */
.ant-menu-horizontal {
  border-bottom: 1px solid white;
}
.arrowicon {
  margin-left: 5px;
  font-size: 23px;
}
/* 菜单 end */
</style>



// WEBPACK FOOTER //
// src/components/header.vue